<div class="indicator" [ngClass]="color"></div>
